<template>
  <div id="channelPacket">
    <el-main element-loading-text="loading" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)">
      <template>
        <div class="header_p">路由器设置方法</div>

        <div class="channel_conent">

          <div class="zip_channel">
            <p class="title_head" style="color: red">如果加速器网吧版出现以下等问题，需要在路由器上指定加速数据走主光纤并绑定端口：</p>
            <div style="font-size: 14px">
              1.问题表现：绝地求生进程模式卡在加载任务的界面进不去，或者进去很慢，卡大厅，没有开始按钮。<br />
              2.发生频率：每次加速都会发生/偶尔会有，大概10把有2~3把会出现/每天晚上的时候会出现问题，其他时候不会。<br />
              3.发生规模：每台机器都会有/有部分机器会出现，固定的这几台机器/随机的几台机器有问题。<br />
              4.网络情况：多线、分别是电信和联通。<br />
              5.《PUBG吃鸡》藏匿处市场打不开，加速节点上访问无异常，但吃鸡藏匿处对访问速度要求很高，网吧路由器智能限速导致接入效果差访问很慢，需要参照设置配置一下放行策略。<br />
            </div>
          </div>
          
          <div class="zip_channel">
            <p class="title_head" style="color: red">多线路路由设置指引</p>
            <div style="font-size: 14px">
              一：端口说明<br />
              外网IP验证:目的端口-TCP:8764<br />
              加速流量通道:目的端口-TCP&UDP:2080-2088、9997-9999<br />
              加速测速通道:目的端口-TCP&UDP:9443、5312、8000<br /><br />
              二：设置须知<br />
              1、多线路出口网吧请将以上端口设置走固定IP出口。<br />
              2、如遇到游戏刷新慢等问题，请将以上端口在路由器做不限速处理。
            </div>
          </div>

          <a v-bind:href="'https://cdn-js.yebaojiasu.com/netbar/派网设置教程.docx'" class="scanning">
            <el-button type="goon" size="medium">下载派网设置教程</el-button>
          </a>
        </div>
      </template>
    </el-main>

    <!-- <el-dialog title="安装说明" :visible.sync="dialogVisible" width="44%">
      <img src="../assets/jt.png" alt class="title_img" />
      <span
        class="explain"
      >说明： 请将该开机程序放到极限电竞加速器客户端下面，并设置为开机启动，请不要修改该目录下极限电竞加速器的启动程序名称（SpeedClient），否则将不能统计有效终端，一个终端累计运行达到90分钟及以上，为一个有效终端，一个终端一天统计一次，终端数据实时显示。</span>
    </el-dialog> -->
  </div>
</template>

<script>
  export default {
    name: "routerSetup",
    data() {
      return {
      };
    },
    created() {
    },
    methods: {
    }
  };
</script>

<style scoped lang="scss">
  .title_img {
    width: 800px;
    height: 500px;
  }

  .explain {
    padding-top: 20px;
    color: #39c2b8;
    font-weight: bold;
    padding-right: 50px;
    font-size: 16px;
  }

  .addd {
    position: relative;
  }

  .switvch {
    position: absolute;
    top: 40px;
    left: 40%;
  }

  .scanning {
    // background: #6692ff;
    // line-height: 40px;
    // padding-left: 20px;
  }

  .alldown_package {
    margin-top: 20px;
    font-size: 16px;

    span {
      color: #5f95cc;
    }
  }

  .channel_conent {
    // border: 1px solid #bbbbbb;

    .zip_channel {
      // border-bottom: 1px solid #bbbbbb;
      background-color: #fff;
      margin-bottom: 30px;
      padding: 30px 20px;

      .title_head {
        margin: 0;
        line-height: 20px;
        font-size: 16px;
        color: #535353;
        margin-bottom: 20px;
      }

      .thing2 {
        padding: 0;
      }

      // padding-bottom: 70px;
    }
  }

  .header_p {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #535353;
  }


  .all_price span {
    font-size: 22px;
    font-weight: bold;
    color: #000;
  }

  .headerData,
  .alldown {
    div {
      position: relative;

      img {
        position: absolute;
        top: 10px;
        left: 8px;
        width: 20px;
        height: 20px;
      }
    }
  }

  #ul_firest li {
    flex: 3;
  }


  .thing,
  .thing2 {
    overflow: hidden;
    padding-left: 50px;
    padding-bottom: 10px;

  }

  .thing {
    position: relative;

    img {
      position: absolute;
      top: 10px;
      left: 60px;
      width: 20px;
      height: 20px;
    }
  }

  .thing a {
    // float: left;

    // color: #fff;
    // width: 180px;
    // text-align: center;
    // border-radius: 0px;
    // padding: 10px 20px;

    // margin-right: 40px;
  }

  .thing2 a {
    // color: #fff;
    // width: 180px;
    // text-align: center;
    // margin-bottom: 10px;
    // border-radius: 0px;
    // padding: 10px 20px;

  }

  .thing .download_span {
    float: left;
    color: #000;
    border-radius: 0px;
    padding: 10px 20px;
    margin-right: 40px;
  }

  .thing>li {
    float: left;
    margin: 5px 10px;
    list-style: none;
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    background: #fff;

    color: #666;
  }

  .thing>li>a {
    color: #666;
  }

  .thing>li>a>p {
    overflow: hidden;
  }

  .thing>li>a>p>span:nth-child(1) {
    float: left;
  }

  .thing>li>a>p>span:nth-child(2) {
    float: right;
    color: #ff0000;
  }

  .fun>li {
    float: left;
    list-style: none;
    margin-right: 15px;
  }
</style>